import { isValidEnabledProducts } from "@/business/product-access";
import { useBusiness } from "@/core/business";

// Read the selected business already loaded by the provider. Never reuse another
// business's selections while switching, or infer access from legacy flags.
export const useBusinessProducts = () => {
  const { businessId, selectedBusiness, isLoading, isError } = useBusiness();
  const settings =
    !isLoading && !isError && businessId && selectedBusiness?.id === businessId
      ? selectedBusiness.enabled_products
      : undefined;
  return {
    settings,
    isLoading,
    hasValidSettings: isValidEnabledProducts(settings),
  };
};
